import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HowItWorks from "../pages/how-it-works/page";
import ForIndividuals from "../pages/for-individuals/page";
import ForCompanies from "../pages/for-companies/page";
import FAQ from "../pages/faq/page";
import Apply from "../pages/apply/page";
import AccessLevels from "../pages/access-levels/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/for-individuals",
    element: <ForIndividuals />,
  },
  {
    path: "/for-companies",
    element: <ForCompanies />,
  },
  {
    path: "/access-levels",
    element: <AccessLevels />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/apply",
    element: <Apply />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
